export default function newsletter() {
  
  var requestRunning = false;
  
  function validateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  } 

  function validateForm() {
    if(validateEmail($('#email').val())){
      $('.form__textwrapper').removeClass('focus failed').addClass('success');
      $('.form__textwrapper .service-message').text('');
      return true;
    } else {
      $('.form__textwrapper').removeClass('focus success').addClass('failed');
      $('.form__textwrapper .service-message').text('Formato email non valido');
      return false;
    }
  }
  
  function init() {
    $('#newsletter .btn-cta').on('click',function(e) {
      e.preventDefault();
      if (requestRunning) {
        return;
      }
      if(validateForm()){ 
        var dataform = $('#form').serialize();
        requestRunning = true;
        $.ajax({
          url: "https://3o91z94zfa.execute-api.eu-west-1.amazonaws.com/prod", 
          method: "POST",
          data: dataform,
          dataType: "json",
          success: function(data) {
            $('.form__textwrapper').removeClass('focus failed').addClass('success');
            $('.form__textwrapper .service-message').text('Thank you!');
            //requestRunning = false;
          }
        });
      }
    });
  }

  if($('#newsletter').length > 0) {
    $( document ).ready(function() {
      init()
    });
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/newsletter.js